import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.form`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
`;

export const Input = styled.input.attrs({
  type: 'radio',
})`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const Cor = styled.label<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  cursor: pointer;

  &:hover {
    background-color: ${({ color }) => darken(0.1, color)};
  }

  ${Input}:checked + && {
    transform: scale(1.2);
    border: 2px solid ${({ theme }) => theme.colors.textBackground};
  }
`;
